import * as Yup from 'yup';

const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;

const validationSchema = Yup.object().shape({
  username: Yup.string().required('Username is required '),
  password: Yup.string()
    .required('Password is required')
    .min(4, 'Password is too short - should be 4 chars minimum.')
    .max(24, 'Password must not exceed 24 characters')
    .matches(
      PWD_REGEX,
      ' 4 to 24 characters, Must begin with a letter,and letters, numbers, underscores, hyphens allowed.'
    ),
  confirmPassword: Yup.string()
    .required('Confirm Password is required')
    .oneOf([Yup.ref('password')], 'Confirm Password does not match'),
  email: Yup.string().email().required('Email is required'),
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
});

export default validationSchema;




